export function maskPhone(v: string) {
	const d = v.replaceAll(/\D/gu, "").slice(0, 11);

	if (d.length > 10) {
		return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
	}

	if (d.length > 6) {
		return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
	}

	if (d.length > 2) {
		return `(${d.slice(0, 2)}) ${d.slice(2)}`;
	}

	if (d.length > 0) {
		return `(${d}`;
	}

	return "";
}

export function maskCpf(value: string) {
	const digits = value.replaceAll(/\D/gu, "").slice(0, 11);

	if (digits.length > 9) {
		return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
	}

	if (digits.length > 6) {
		return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
	}

	if (digits.length > 3) {
		return `${digits.slice(0, 3)}.${digits.slice(3)}`;
	}

	return digits;
}

export function maskCep(value: string) {
	const digits = value.replaceAll(/\D/gu, "").slice(0, 8);

	if (digits.length > 5) {
		return `${digits.slice(0, 5)}-${digits.slice(5)}`;
	}

	return digits;
}

export function maskBirthDate(value: string) {
	const digits = value.replaceAll(/\D/gu, "").slice(0, 8);

	if (digits.length > 4) {
		return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
	}

	if (digits.length > 2) {
		return `${digits.slice(0, 2)}/${digits.slice(2)}`;
	}

	return digits;
}
